module.exports = __webpack_public_path__ + "static/media/man.309b9d82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/core/assets/images/man.jpg
// module id = 590
// module chunks = 0 2